import React, { render, createElement } from 'preact/compat'

import { App } from './app'
import { initialValues as defaultProps } from './defaults'
import './index.css'

const components = Object.freeze({
  App,
})

const renderElement = <T extends ReturnType<typeof components[keyof typeof components]>>(
  elementName: keyof typeof components,
  parentElement: Element,
  props?: React.ComponentProps<typeof components[keyof typeof components]>,
) => {
  if (!parentElement) {
    throw new Error('A parent element must be provided')
  }
  if (!components[elementName]) {
    throw new Error(`Unknown Component ${elementName}`)
  }
  let componentRef: preact.VNode<T> | null | undefined

  // App styles are scoped to reside within a container containing the `syn-npc` class.
  parentElement.classList.add('syn-npc')

  const element = createElement(components[elementName], {
    ...defaultProps,
    ...props,
    ref: (ref: preact.VNode<T>) => (componentRef = ref),
  })

  render(element, parentElement)
  return componentRef
}

export { renderElement, components, defaultProps }
